import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const PopularSearches = styled.div`
  padding: 0 ${layout.measurements.spacing050} 0;
  margin-bottom: ${layout.measurements.spacing025};
  display: flex;
  flex-wrap: wrap;
  gap: ${layout.measurements.spacing050};
`;
